"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchStyles = exports.searchIcon = exports.base = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("input{font-size:", theme.fontSize.base, ";padding:", (0, _util.rem)(5), " ", (0, _util.rem)(12), " ", (0, _util.rem)(6), ";&::placeholder{font-style:italic;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

exports.base = base;

var searchIcon = function searchIcon(theme) {
  return /*#__PURE__*/(0, _react.css)("cursor:pointer;flex-shrink:0;display:flex;align-items:center;padding:", (0, _util.rem)(5), " ", (0, _util.rem)(12), ";color:", theme.color.buttonPrimary.border, ";&:hover{color:", theme.color.buttonPrimary.backgroundHover, ";}svg{width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:searchIcon;"));
};

exports.searchIcon = searchIcon;

var searchBtn = function searchBtn(theme) {
  return /*#__PURE__*/(0, _react.css)("pointer-events:none;color:", theme.color.monochrome.mediumDark, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:searchBtn;"));
};

var searchStyles = {
  base: base,
  searchIcon: searchIcon,
  searchBtn: searchBtn
};
exports.searchStyles = searchStyles;
//# sourceMappingURL=Search.styles.js.map